import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-racq-dark-grey text-lg-bold mt-6 mb-3" }
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = { class: "flex text-m-bold text-racq-dark-grey" }
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = { class: "text-m text-dark-grey-text" }

import { ref } from 'vue';
import { ITableGroup, ITableGroupColumn } from '@/interfaces/entities/table-group.interface';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import PercentageBar from '@/components/PercentageBar/PercentageBar.vue';
import ShowHideButton from '@/components/ShowHideButton/ShowHideButton.vue';
import { toBool, toNumber } from '@/utils/convert';
import { showTooltipOnTriggerClick } from '@/plugins/tooltip/renderTooltip';

// Define props and emitters
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'TableControlItem',
  props: {
    tableData: {}
  },
  setup(__props: any) {



const isExpanded = ref(false);

// Define Functions
// ------------------------------------------------------------- //
const getGridTemplate = (numberOfColumns: number, numberOfRow: number, showMore?: boolean, numberOfItems?: number) => {
  return {
    gridTemplateRows: `${showMore && !isExpanded.value ? `repeat(${numberOfItems}, minmax(0, auto))` : `repeat(${numberOfRow}, minmax(0, auto))`}`,
    gridTemplateColumns: `repeat(${numberOfColumns}, minmax(0, 1fr))`,
  };
};
const getBorderClass = (
  index: number,
  tableColumn: ITableGroupColumn,
  showMore?: boolean,
  initialNumberOfItemsToShow?: number
) => {
  if (showMore) {
    return !isExpanded.value && index == initialNumberOfItemsToShow! - 1
      ? ''
      : index == tableColumn.rows.length - 1
        ? ''
        : 'border-b-0 border-b-0';
  } else {
    return index == tableColumn.rows.length - 1 ? '' : 'border-b-0 border-b-0';
  }
};

const toggleContent = () => {
  isExpanded.value = !isExpanded.value;
};
const showModal = (title?: string, content?: string) => {
  (window as any)?.showRACQTooltipModal(title, content);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.tableSections, (table, key) => {
    return (_openBlock(), _createElementBlock("div", { key: key }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(RichText), {
          field: table.heading
        }, null, 8, ["field"])
      ]),
      (table.tableColumn && table.tableColumn.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "grid grid-flow-col gap-x-2 md:gap-x-3",
            style: _normalizeStyle(
        getGridTemplate(
          table.tableColumn.length,
          table.tableColumn[0].rows.length,
          _unref(toBool)(table.showMoreButton?.value),
          _unref(toNumber)(table.initialNumberOfItemsToShow?.value)
        )
      )
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.tableColumn, (tableColumn, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "contents"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toBool)(table.showMoreButton?.value)
            ? isExpanded.value
              ? tableColumn.rows
              : tableColumn.rows.slice(0, _unref(toNumber)(table.initialNumberOfItemsToShow?.value))
            : tableColumn.rows, (tableRow, row) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row,
                    class: _normalizeClass(["p-4 border border-racq-blue-background", [
            tableColumn.highlighted ? 'bg-racq-anti-flash-white' : '',
            getBorderClass(
              row,
              tableColumn,
              _unref(toBool)(table.showMoreButton?.value),
              _unref(toNumber)(table.initialNumberOfItemsToShow?.value)
            ),
            row == 0 ? 'rounded-t' : '',
            row == tableColumn.rows.length - 1 ? 'rounded-b' : '',
          ]])
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(RichText), {
                            tag: "span",
                            field: tableRow.heading
                          }, null, 8, ["field"]),
                          (tableRow.tooltipContent?.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                id: `tooltip-row${row}-column${index}`,
                                type: "button",
                                class: "questionmark-icon js-tooltip-trigger -mt-0.5 inline-block",
                                "aria-label": "show tooltip",
                                onClick: 
                    (e) => {
                      _unref(showTooltipOnTriggerClick)(e, tableRow.tooltipContent?.value ?? '');
                    }
                  
                              }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_5, [
                        _createVNode(_unref(RichText), {
                          field: tableRow.description
                        }, null, 8, ["field"])
                      ]),
                      (tableRow.percentage?.value)
                        ? (_openBlock(), _createBlock(PercentageBar, {
                            key: 0,
                            percentage: tableRow.percentage.value
                          }, null, 8, ["percentage"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ], 4))
        : _createCommentVNode("", true),
      (_unref(toBool)(table.showMoreButton?.value))
        ? (_openBlock(), _createBlock(ShowHideButton, {
            key: 1,
            showMore: isExpanded.value,
            showLessLabel: table.showLessButtonText?.value,
            showMoreLabel: table.showMoreButtonText?.value,
            onClick: toggleContent
          }, null, 8, ["showMore", "showLessLabel", "showMoreLabel"]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})